import React from 'react';

const FidelityGoDisclaimer = () => (
  <div className="disclaimer">
    <p>
      Nerdwallet, Inc. (“Nerdwallet”) is a non-client paid promoter of Fidelity
      Personal and Workplace Advisors, LLC (“FPWA”), which sponsors the Fidelity
      Go program. FPWA, through its affiliates, pays Nerdwallet $125 for each
      Fidelity Go account opened by a Nerdwallet website using the same
      electronic device used to click on the Fidelity Go referral link
      maintained on the Nerdwallet webpage (the “Referral Link”). Only accounts
      opened within thirty (30) days of the user clicking the Referral Link
      qualify for payment.
    </p>
    <p>
      Nerdwallet maintains a retirement plan program with a FPWA affiliate. The
      compensation described above and Nerdwallet’s customer relationship with a
      FPWA affiliate create a conflict of interest, as they incentivize
      Nerdwallet to refer business to FPWA through the Referral Link, the
      placement of the Referral Link on Nerdwallet’s webpage, and could
      influence the views reflected in Nerdwallet’s review of the Fidelity Go
      product and FPWA’s services generally. Nerdwallet mitigates this conflict
      by maintaining the objectiveness of the content of its reviews relative to
      the receipt of payment. Please see Nerdwallet’s website for more
      information.
    </p>
    <p>
      Nerdwallet is not affiliated with FPWA or Fidelity Investments and is not
      authorized to provide investment advice, securities, or account
      recommendations on behalf of FPWA and its affiliated broker-dealers and
      investment advisers. Keep in mind that investing involves risk. The value
      of your investment will fluctuate over time, and you may gain or lose
      money.
    </p>
  </div>
);

FidelityGoDisclaimer.propTypes = {};
FidelityGoDisclaimer.displayName = 'FidelityGoDisclaimer';

export default FidelityGoDisclaimer;
